import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxPermissionsService } from 'ngx-permissions';
import { Subject, takeUntil } from 'rxjs';
import { trackById } from 'src/app/core/utils/track-by';
import {
  DashboardMappingState,
  DashboardMappingStatus,
} from 'src/app/features/company-portal/modules/settings/models/MetabaseModels';
import { AnalyticsMenuService } from '../../services/analytics-menu.service';

@Component({
  selector: 'app-analytics-menu',
  templateUrl: './analytics-menu.component.html',
  styleUrls: ['./analytics-menu.component.css'],
  standalone: false,
})
export class AnalyticsMenuComponent implements OnInit, OnDestroy {
  @Input() appId!: number;
  @Input() baseRoute!: string;
  @Input() companyId!: number;

  menuItems: DashboardMappingState[] = [];
  isExpanded = false;
  trackById = trackById;
  dashboardMappingStatus = DashboardMappingStatus;
  private destroy$ = new Subject<void>();

  constructor(
    private analyticsMenuService: AnalyticsMenuService,
    private permissionsService: NgxPermissionsService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    if (!this.companyId) {
      this.companyId = this.getCompanyId();
    }

    this.analyticsMenuService.loadMenuItems(this.companyId, this.appId);

    this.analyticsMenuService
      .getMenuItems()
      .pipe(takeUntil(this.destroy$))
      .subscribe((items) => {
        this.menuItems = items;
      });
  }

  getCompanyId(): number {
    return Number(JSON.parse(localStorage.getItem('user') || '{}')?.companyid) || 0;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  toggleMenu(): void {
    this.isExpanded = !this.isExpanded;
  }

  navigateToDashboard(mapping: DashboardMappingState): void {
    this.router.navigate([`${this.baseRoute}/analytics`, mapping.id]);
  }

  hasAnalytics(): boolean {
    return this.menuItems.length > 0;
  }

  get isAdminUser(): boolean {
    return !!this.permissionsService.getPermission('Analytics:ManageDashboards');
  }
}
